import { connect } from 'react-redux';

import {
  getRepositoryMainBranch,
  getRepositoryBranchingModel,
} from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import FilteredRefList from '../../components/ref-selector/filtered-ref-list';

const mapStateToProps = (state: BucketState) => ({
  mainRef: getRepositoryMainBranch(state),
  branchingModel: getRepositoryBranchingModel(state),
});

export default connect(mapStateToProps)(FilteredRefList);
